import Vue from 'vue';
import Router from 'vue-router';
import Orbc from './views/Orbc.vue';
import Assessments from './views/Assessments.vue';
import Datasources from './views/Datasources.vue';
import Login from './views/Login.vue';
import Home from './views/Home.vue';
import DatasourcesConfig from './views/DatasourcesConfig.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/orbc/:resource',
      name: 'orbc',
      component: Orbc,
      props: true,
    },
    {
      path: '/assessments',
      name: 'assessments',
      component: Assessments,
    },
    {
      path: '/datasources/:resource',
      redirect: '/datatubes/:resource',
    },
    {
      path: '/datatubes/config',
      name: 'datasource-config',
      component: DatasourcesConfig,
    },
    {
      path: '/datatubes/:resource',
      name: 'datasource',
      component: Datasources,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        public: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.public || !!window.localStorage.getItem('token')) return next();

  next({
    path: '/login',
  });
});

export default router;
